import React, { useEffect, useState } from "react";
import { fmtDate } from "@/lib/dates";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Award, Download } from "lucide-react";
import { toast } from "sonner";

export default function Certificates() {
  const [certs, setCerts] = useState([]);
  useEffect(() => { api.get("/certificates/me").then((r) => setCerts(r.data)).catch(() => {}); }, []);

  const download = async (cert) => {
    try {
      const res = await api.get(`/certificates/${cert.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `${cert.cert_number}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download failed"); }
  };

  return (
    <div>
      <PageHeader title="My certificates" subtitle="KOHC-branded, CPD-detailed certificates. Download for your compliance evidence pack." />
      <a href="https://www.facebook.com/groups/27941660172109456" target="_blank" rel="noreferrer" data-testid="cert-community-banner"
        className="block rounded-2xl bg-brand text-white p-5 mb-6 hover:bg-brand-hover transition-colors">
        <div className="flex items-center gap-3">
          <Award className="h-6 w-6 text-coral flex-shrink-0" />
          <div><div className="font-semibold">Join our Community Hub</div>
          <div className="text-sm text-white/70">Open to everyone who has completed any of our training courses.</div></div>
        </div>
      </a>
      {certs.length === 0 ? (
        <div className="text-center py-16 bg-cream-card border border-cream-deep rounded-xl">
          <Award className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">No certificates yet. Complete a course or attend a live session to earn one.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
          {certs.map((c) => (
            <div key={c.id} data-testid={`cert-${c.id}`} className="bg-cream-card border border-cream-deep rounded-2xl p-6 relative overflow-hidden">
              <div className="absolute top-0 right-0 h-24 w-24 bg-coral/10 rounded-bl-[3rem]" />
              <Award className="h-8 w-8 text-coral relative" />
              <Badge variant="outline" className="mt-3">{c.kind}</Badge>
              <h3 className="font-heading font-bold text-brand text-lg mt-2">{c.course_title}</h3>
              <div className="text-sm text-muted-foreground mt-3 space-y-1">
                <div>Awarded to <span className="font-medium text-foreground">{c.user_name}</span></div>
                <div>{fmtDate(c.issued_at)} · {c.cpd_hours} CPD hrs</div>
                <div className="text-xs">No: {c.cert_number}</div>
              </div>
              <Button data-testid={`download-cert-${c.id}`} onClick={() => download(c)} className="mt-4 w-full rounded-full bg-brand hover:bg-brand-hover text-white"><Download className="h-4 w-4 mr-2" />Download PDF</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
